import React, { useState } from "react";
import { Image as ImageIcon } from "lucide-react";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

// Uploaded images are served relatively (/api/warehouse/image/..); Amazon/pasted links are absolute.
export const imgSrc = (v) => (!v ? "" : /^https?:\/\//i.test(v) ? v : `${BACKEND}${v}`);

export default function ProductThumb({ src, size = 40, title }) {
  const [err, setErr] = useState(false);
  if (!src || err) {
    return (
      <div title={title} className="rounded-md bg-[#151515] border border-[#222] flex items-center justify-center text-[#444] shrink-0" style={{ width: size, height: size }}>
        <ImageIcon className="h-4 w-4" />
      </div>
    );
  }
  return <img src={imgSrc(src)} onError={() => setErr(true)} alt="" title={title} className="rounded-md object-cover border border-[#222] bg-[#151515] shrink-0" style={{ width: size, height: size }} />;
}
